import { forwardRef } from 'react'
import { Icon } from 'semantic-ui-react'

import { cn } from '@repo/utils'

import styles from './index.css'

import type { ButtonHTMLAttributes, ComponentProps, ReactNode } from 'react'

interface SimpleButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string
  children?: ReactNode
  className?: string
  icon?: ComponentProps<typeof Icon>['name']
  iconClassName?: string
  itemsDirection?: 'btt' | 'ltr' | 'rtl' | 'ttb'
  primary?: boolean
  secondary?: boolean
  tertiary?: boolean
  value?: string
}

const SimpleButton = forwardRef<HTMLButtonElement, SimpleButtonProps>(
  (
    {
      ariaLabel,
      children,
      className,
      icon,
      iconClassName,
      itemsDirection = 'ltr',
      primary = false,
      secondary = false,
      tertiary = false,
      value,
      ...props
    },
    ref,
  ) => {
    const iconButton = !!icon && !(children || value)

    return (
      <button
        type="button"
        {...props}
        aria-label={ariaLabel || value}
        className={cn(
          styles.button,
          className,
          iconButton && styles.iconButton,
          itemsDirection === 'rtl' && styles.itemsRTL,
          itemsDirection === 'ttb' && styles.itemsTTB,
          itemsDirection === 'btt' && styles.itemsBTT,
          tertiary && styles.tertiary,
          secondary && styles.secondary,
          primary && styles.primary,
        )}
        ref={ref}
        value={value || ariaLabel}
      >
        {!!icon && <Icon className={cn(styles.icon, !iconButton && styles.iconSpace, iconClassName)} name={icon} />}
        <span>{children || value}</span>
      </button>
    )
  },
)

SimpleButton.displayName = 'SimpleButton'

export default SimpleButton
